import React, { Component } from 'react';

import { Button, Nav, Navbar, NavbarBrand, NavItem } from "reactstrap";
import cmkLogo from '../../../assets/img/logo.png';
import FontAwesome from 'react-fontawesome';
import { NavLink } from "react-router-dom";
import { logout } from "../../../store/actions";
import { connect } from "react-redux";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import axios from "../../../axios-cmk";
import moment from "moment";
import './CMKNavigation.css'
import Aux from "../../../hoc/Aux/Aux"

class CMKNavigation extends Component {


    state = {
        currentTime: null,
    };

    componentDidMount() {
        this.timer = setInterval(this.tick, 50);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    tick = () => {
        this.setState({ currentTime: moment().format("HH:mm:ss") });
    };

    render() {

        const authenticatedNavsLeft = this.props.isAuthenticated ? (
            <Aux>
                <NavItem>
                    <NavLink to="/calendar" className="nav-link">Terminarz</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink to="/reports" className="nav-link"> Wizyty </NavLink>
                </NavItem>
            </Aux>
        ) : '';

        const authenticatedNavsRight = this.props.isAuthenticated ? (
            <NavItem>
                <Button outline color="btn btn-outline-warning" onClick={this.props.logout}
                        className='btn-logout'>
                    <FontAwesome name='sign-out' /> Wyloguj
                </Button>
            </NavItem>
        ) : '';

        return (
            <Navbar className="navbar navbar-expand-lg navbar-light bg-light">
                <Nav className="mr-auto" navbar>
                    <NavbarBrand href="/dashboard">
                        <img src={cmkLogo} width="30" height="30" alt=""
                             className="d-inline-block align-top navbarLogo" /> CMK
                    </NavbarBrand>
                    {authenticatedNavsLeft}
                </Nav>
                <Nav className="ml-auto" navbar>
                    <NavItem>
                        <span className="currentTime">
                        {this.state.currentTime}
                        </span>
                    </NavItem>
                    {authenticatedNavsRight}
                </Nav>
            </Navbar>
        )
    }
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        isAuthenticated: state.auth.token !== null,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        logout: () => dispatch(logout()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(CMKNavigation, axios));



// WEBPACK FOOTER //
// ./src/components/Navigation/CMKNavigation/CMKNavigation.js